export default {
    general: {
        back:     'Nazaj',
        next:     'Naprej',
        cancel:   'Prekliči',
        from:     'od',
        night:    'nočitev',
        nights:   '{count} noč | {count} noči | {count} noči | {count} noči',
        loading:  'Nalagam …',
        language: 'Jezik',
        theme:    'Videz',
    },
    errors: {
        generic_error: 'Nekaj je šlo narobe. Poskusite znova.',
        invalid_data:  'Podatki niso pravilni.',
        not_found:     'Ne najdemo.',
        offline:       'Povezave s hotelom ni. Preverite internet in poskusite znova.',
        no_house:      'Ta hotel trenutno ne sprejema spletnih rezervacij.',
        taken:         'To sobo je medtem nekdo rezerviral. Izberite drugo ali drug termin.',
        too_many:      'Preveč poskusov. Počakajte trenutek in poskusite znova.',
        too_many_guests: 'V tej sobi ni prostora za toliko oseb.',
        booking_failed:  'Rezervacije ni bilo mogoče oddati.',
        offer_gone:      'Ponudba ne velja več. Prikazane so redne cene hiše.',
    },
    step: {
        dates:   'Termin',
        rooms:   'Soba',
        guest:   'Podatki',
        summary: 'Povzetek',
        done:    'Potrjeno',
    },
    search: {
        title:          'Rezervirajte sobo',
        lead:           'Izberite termin in število oseb; prikazali vam bomo proste sobe in ceno.',
        arrival:        'Prihod',
        departure:      'Odhod',
        adults:         'Odrasli',
        children:       'Otroci',
        submit:         'Poišči proste sobe',
        stay_too_long:  'Bivanje je lahko dolgo največ {nights} noči.',
        departure_after: 'Odhod mora biti po prihodu.',
        arrival_past:   'Prihod ne more biti v preteklosti.',
    },
    package: {
        title: 'V paketu',
        included: 'vključeno',
        surcharges_total: 'Doplačila',
        kind_room_service: 'Postrežba v sobo',
        kind_dining: 'Obrok',
        kind_facility: 'Zmogljivost',
        kind_parking: 'Parkiranje',
        kind_service: 'Storitev',
        kind_product: 'Izdelek',
        when_arrival: 'ob prihodu',
        when_each_night: 'vsako noč',
        when_departure: 'ob odhodu',
    },
    rooms: {
        component_gone: 'Del paketa za te dni ni na voljo',
        component_gone_hint: 'Zasedeno: {what}. Poskusite z drugimi datumi — paket še vedno velja.',
        title:      'Proste sobe',
        stay:       '{arrival} – {departure} · {nights} · {guests}',
        none:       'Za izbrani termin ni prostih sob.',
        none_hint:  'Poskusite z drugim terminom ali z manj osebami.',
        change:     'Spremeni termin',
        choose:     'Izberi',
        per_stay:   'za celotno bivanje',
        left:       'Na voljo še {count} soba | Na voljo še {count} sobi | Na voljo še {count} sobe | Na voljo še {count} sob',
        sleeps:     'Do {count} osebe | Do {count} oseb | Do {count} oseb | Do {count} oseb',
        beds:       '{count} postelja | {count} postelji | {count} postelje | {count} postelj',
        photo_of:   'Fotografija sobe {name}',
        offer_price: 'cena po ponudbi (−{percent} %)',
        early_booking:       'Zgodnja rezervacija −{percent} %',
        early_booking_saved: 'prihranek {amount}',
        offer_applied: 'Cene spodaj so po tej ponudbi, znižane za {percent} %.',
        offer_gone: 'Ponudba ne velja več',
        offer_gone_hint: 'Hiša je ponudbo umaknila ali spremenila, zato so spodaj redne cene.',
    },
    board: {
        none:       'Brez obrokov',
        breakfast:  'Z zajtrkom',
        half_board: 'Polpenzion',
        full_board: 'Polni penzion',
        all_inclusive: 'All inclusive',
    },
    guest: {
        title:      'Vaši podatki',
        lead:       'Rezervacijo bomo potrdili na ta e-naslov.',
        first_name: 'Ime',
        last_name:  'Priimek',
        email:      'E-naslov',
        phone:      'Telefon',
        notes:      'Sporočilo hotelu',
        notes_hint: 'Neobvezno — na primer ura prihoda ali posebna želja.',
        required:   'To polje je obvezno.',
        email_bad:  'Vpišite veljaven e-naslov.',
        submit:     'Naprej na povzetek',
    },
    summary: {
        room_only: 'Nastanitev',
        payment_optional: 'Plačate lahko zdaj s kartico ali ob prihodu na recepciji.',
        payment_deposit: 'Za potrditev poravnate predplačilo {amount} ({percent} % zneska) — zdaj ali s povezavo iz e-sporočila. Preostanek ob prihodu na recepciji.',
        payment_full: 'Za potrditev poravnate celoten znesek {amount} — zdaj ali s povezavo iz e-sporočila.',
        title:     'Povzetek',
        lead:      'Preverite podatke in potrdite rezervacijo.',
        stay:      'Bivanje',
        room:      'Soba',
        offer:     'Ponudba',
        early_booking: 'Zgodnja rezervacija',
        guests:    'Osebe',
        contact:   'Kontakt',
        city_tax:  'Turistična taksa {amount} na osebo na nočitev',
        total:     'Skupaj z DDV',
        payment:   'Plačilo ob prihodu na recepciji.',
        cancellation: 'Brezplačna odpoved do {date}',
        terms:     'Splošni pogoji',
        accept:    'Strinjam se s splošnimi in odpovednimi pogoji.',
        accept_required: 'Za rezervacijo je treba potrditi pogoje.',
        submit:    'Potrdi rezervacijo',
        sending:   'Oddajam …',
    },
    done: {
        payment_optional: 'Plačate lahko zdaj s kartico ali ob prihodu na recepciji.',
        payment_remainder: 'Preostanek {amount} poravnate ob prihodu na recepciji.',
        payment_required: 'Za potrditev bivanja poravnajte {amount}',
        payment_required_hint: 'Soba je rezervirana in vas čaka. Znesek lahko poravnate zdaj ali s povezavo iz potrditvenega e-sporočila.',
        payment_done: 'Plačilo je prejeto. Hvala!',
        pay_now: 'Plačaj {amount}',
        pay_later: 'Povezavo za plačilo najdete tudi v potrditvenem e-sporočilu.',
        pay_failed: 'Plačilne strani ni bilo mogoče odpreti. Poskusite znova ali uporabite povezavo iz e-sporočila.',
        title:      'Rezervacija je potrjena',
        number:     'Številka rezervacije',
        keep:       'Številko shranite — z njo vas najdemo, če pokličete.',
        mail_sent:  'Potrditev smo poslali na {email}.',
        mail_none:  'Potrditve po e-pošti nismo mogli poslati; hotel vas bo poklical.',
        payment:    'Plačilo ob prihodu na recepciji.',
        again:      'Nova rezervacija',
    },
    occupancy: {
        adults:   '{count} odrasel | {count} odrasla | {count} odrasli | {count} odraslih',
        children: '{count} otrok | {count} otroka | {count} otroci | {count} otrok',
    },
    license: {
        title: 'Ta storitev ni vključena',
        lead: 'Ta hotel spletnega rezerviranja ne omogoča, zato prek te strani ni mogoče rezervirati sobe.',
        contact: 'Pokličite recepcijo hotela — z veseljem vam uredijo rezervacijo.',
    },
    closed: {
        title: 'Rezervacije trenutno niso mogoče',
        lead:  'Ta hotel trenutno ne prodaja sob prek spleta. Pokličite recepcijo in z veseljem vam pomagajo.',
    },
}
